"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  title: 'Audio',
  dialButtonVolume: 'Dial Button Volume',
  ringtoneVolume: 'Ringtone Volume',
  callVolume: 'Call Volume',
  muteCalls: 'Mute Calls',
  outputDevice: 'Output Device',
  inputDevice: 'Input Device',
  micPermission: 'Microphone Permission',
  noDevice: 'No device',
  checkMicPermission: 'Check Permission',
  micNoPermissionMessage: 'The app does not have permission to use microphone',
  noLabel: 'Unknown device',
  notSetSinkIdTip: "Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up.",
  noLabelTip: "Sorry, your current browser permissions aren't set to allow us to access your audio input devices.",
  clickHere: 'Click here',
  defaultOutputDevice: 'Default output device'
};
exports["default"] = _default;
//# sourceMappingURL=en-US.js.map
